import { memo } from "react";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { SxProps } from "@mui/material";

interface TreeViewItemProps {
    id: string;
    labelContent: string | React.ReactNode;
    children?: React.ReactNode;
    sx?: SxProps;
}

const TreeViewItem = memo(({ id, labelContent, children, sx }: TreeViewItemProps) => {
    return (
        <TreeItem
            itemId={id}
            label={labelContent}
            sx={{
                ...sx,
                "& .MuiTreeItem-content": {
                    padding: 0.75,
                },
            }}
        >
            {children}
        </TreeItem>
    );
});

export default TreeViewItem;
